import { css, html, LitElement } from "lit";
import {
  executeGetInvitationCofounder,
  executeCreateCoFounder,
} from "./invite-cofounder.requests";
import Check from "../../utils/assets/img/icon/check-green.svg";

import "@shoelace-style/shoelace/dist/components/spinner/spinner.js";

export default class CreateNewCofounder extends LitElement {
  static styles = css`
    sl-dialog::part(body) {
      padding-top: 0;
    }

    .form-content {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .form-content > .msg-error {
      color: red;
      font-size: 14px;
      font-weight: bold;
      margin-top: -10px;
      margin-bottom: 0px;
    }

    .success-message {
      padding: 0px 10px 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }

    .success-message > sl-icon {
      font-size: 54px;
    }

    .success-message > p {
      margin: 0px;
      text-align: center;
      line-height: 18px;
    }
    .control-blue-button::part(base) {
      background: #1d52f7;
      border-radius: 32px;
      border: 1px solid #1d52f7;
      color: white;
      line-height: 160%;
      font-size: 16px;
      padding: 3px 12px;
      display: flex;
      align-items: center;
    }
    .sl-input-container::part(form-control-help-text) {
      color: #222429;
      padding: 4px 12px 2px;
      line-height: 140%;
      font-size: 16px;
      font-weight: 600;
      position: absolute;
      top: 0;
    }
    .sl-input-container::part(form-control-input) {
      padding-top: 10px;
    }
    .sl-input-container::part(input) {
      top: 10px;
      text-overflow: ellipsis;
      flex-grow: 0;
      width: 100%;
      margin-right: 10px;
    }
    .sl-input-container::part(suffix) {
      margin-left: auto;
    }
    .sl-input-container::part(base) {
      height: 62px;
      display: flex;
    }
    .sl-input-container::part(base) {
      background: #f1f2f4;
      border: 1px solid #f1f2f4;
      border-radius: 12px;
      padding: 10px 12px;
      height: 58px;
      align-items: center;
    }
    .sl-input-container::part(form-control-label) {
      display: none;
    }
    .loader {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.2);
      z-index: 1;
    }
  `;

  static properties = {
    open: { type: Boolean },
    coFounderEmail: { type: String },
    coFounderName: { type: String },
    isSubmitting: { type: Boolean },
    isDisabled: { type: Boolean },
    isLoading: { type: Boolean },
    msgError: { type: String },
  };

  constructor() {
    super();

    this.coFounderEmail = "";
    this.coFounderName = "";
    this.isSubmitting = false;
    this.isSuccessfullySubmitted = false;
    this.msgError = "";
    this.isDisabled = false;
    this.isLoading = true;
    this.close = () => {};
    this.tokenInvitation = new URLSearchParams(window.location.search).get(
      "invitation"
    );
  }

  handleClose(e) {
    if (!this.isSubmitting) {
      this.isSuccessfullySubmitted = false;
      this.msgError = "";
      this.close();
    } else {
      e.preventDefault();
      console.log("IS SUBMITTING");
    }
  }

  async firstUpdated() {
    const { error, data } = await executeGetInvitationCofounder(
      this.tokenInvitation
    );

    this.isLoading = false;
    if (data?.error || error) {
      const msgError = data?.error || error || "An error occurred";
      this.msgError = msgError;
      this.isDisabled = true;
    }
    this.open = true;
    this.coFounderEmail = data?.email;
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.isSubmitting) return;

    // Basic email validation
    const email = this.coFounderEmail.trim();
    const isValidEmail = email && email.includes("@");
    if (!isValidEmail || !this.coFounderName) return;

    this.msgError = "";
    this.isSubmitting = true;
    this.isSuccessfullySubmitted = false;

    const body = {
      email: email,
      name: this.coFounderName,
      token: this.tokenInvitation,
    };

    console.log(this.coFounderName);

    const { error, data } = await executeCreateCoFounder(body);

    this.isSubmitting = false;

    if (data?.error || error) {
      const msgError = data?.error || error || "An error occurred";
      this.msgError = msgError;
      return;
    }

    this.isSuccessfullySubmitted = true;

    // const timer = setTimeout(() => {
    //   this.handleClose();
    //   clearTimeout(timer);
    // }, 5000);
  };

  renderForm() {
    return html`
      <form @submit=${this.handleSubmit}>
        <div class="form-content">
          <sl-input
            class="sl-input-container"
            label="Email"
            type="email"
            required
            .value=${this.coFounderEmail}
            .disabled=${true}
          ></sl-input>
          <sl-input
            class="sl-input-container"
            label="Name"
            type="text"
            required
            placeholder="Your name"
            .value=${this.coFounderName}
            @sl-change=${(e) => (this.coFounderName = e.target.value)}
            .disabled=${this.isSubmitting || this.isDisabled}
          ></sl-input>
          <sl-button
            class="control-blue-button"
            slot="footer"
            variant="primary"
            type="submit"
            .disabled=${this.isSubmitting || this.isDisabled}
            .loading=${this.isSubmitting}
          >
            Create
          </sl-button>
          ${this.msgError
            ? html`<p class="msg-error">${this.msgError}</p>`
            : ""}
        </div>
      </form>
    `;
  }

  renderSuccessfullyMessage() {
    return html`
      <div class="success-message">
        <sl-icon src=${Check}></sl-icon>
        <p>
          Please ask your co-founder to share their log-in details. Use those
          details to log in and then select your co-founder account like on
          Netflix.
        </p>
      </div>
    `;
  }

  render() {
    return html`
      ${this.isLoading
        ? html`
            <div class="loader">
              <sl-spinner style="font-size: 2.5rem;"></sl-spinner>
            </div>
          `
        : html` <sl-dialog
            .open=${this.open}
            @sl-request-close=${this.handleClose}
          >
            <span slot="label">
              <span>Create your co-founder account</span>
            </span>
            ${this.isSuccessfullySubmitted
              ? this.renderSuccessfullyMessage()
              : this.renderForm()}
          </sl-dialog>`}
    `;
  }
}

customElements.define("create-new-cofounder", CreateNewCofounder);
